import axios from "@/libs/api.request";
// 获取订单状态列表
export const getOrderStatusList = (params) => {
  return axios.request({
    url: "/statistics/getNewOrderStatus",
    method: "get",
    params,
  });
};

// 获取最新状态订单
export const getNewOrderStatus = (params) => {
  return axios.request({
    url: "/statistics/getNewStatusAwb",
    method: "get",
    params,
  });
};

// 导出订单状态
export const exportOrderStatus = (params) => {
  return axios.request({
    url: "/statistics/uploadNewOrderStatus",
    method: "get",
    params,
  });
};

// 获取客户组别
export const getCustomerGroup = (params) => {
  return axios.request({
    url: "/user/client/getCustomerGroup",
    method: "get",
    params,
  });
};
